<script setup>
import { useI18n } from 'vue-i18n'
import { bettingConfig } from '@/config/betting'
const { t } = useI18n()

const modelValue = defineModel()

function selectAll(event) {
  if (event && event.target && typeof event.target.select === 'function') {
    event.target.select();
  }
}

defineProps({
  errorMessages: {
    type: [String, Array],
    default: null
  }
})
</script>


<template>
  <v-text-field
    v-model="modelValue"
    :label="$t('events.betting.betAmount')"
    type="number"
    :min="bettingConfig.minAmount"
    :max="bettingConfig.maxAmount"
    variant="outlined"
    prepend-inner-icon="mdi-fleur-de-lis"
    class="mb-4"
    :error-messages="errorMessages"
    :hint="t('betting.rangeHint', { min: bettingConfig.minAmount, max: bettingConfig.maxAmount })"
    persistent-hint
      @focus="selectAll"
  ></v-text-field>
</template>

